<template>
  <div>

    <v-dialog persistent v-if="dialogyetki" v-model="dialogyetki" max-width="900px">
      <v-card color="grey lighten-5">

        <v-flex pa-1 xs12 sm12 md12>
          <v-layout row wrap>
            <v-flex pr-3 pt-3 xs12 sm12>
              <div class="scrollbar" id="style-1">
                <v-card color="white" flat>
                  <v-flex pl-3 pr-3 pt-3 xs12 sm12>

                    <div class="force-overflow">
 <p>
                        <b>Ön Bilgilendirme Koşulları ve Mesafeli Satış Sözleşmesi</b></p>
                      <p>


                      <p>
                        <b>MADDE 1 - TARAFLAR</b></p>
                      <p>
                        <b>1.1 SATICI</b></p>
                      <table>
                        <tr>
                          <th align="left">
                            {{$t('Title_label')}}
                          </th>
                          <td>
                            :
                          </td>
                          <td>
                            Arkman Bilgisayar Teknolojisi ve Yazılım Limited Şirketi
                          </td>
                        </tr>
                        <tr>
                          <th align="left">
                            {{$t('Address_label')}}
                          </th>
                          <td>
                            :
                          </td>
                          <td>
                            Eğitim Mahallesi Ahsen Çıkmazı Sadıkoğlu İş Merkezi 1 Bina No:10 Daire No:50
                            İstanbul / Kadıköy
                            Türkiye
                          </td>
                        </tr>
                        <tr>
                          <th align="left">
                            {{$t('Phonenumber_label')}}
                          </th>
                          <td>
                            :
                          </td>
                          <td>
                            0216 345 79 79 / 0850 811 12 84
                          </td>
                        </tr>

                        <tr>
                          <th align="left">
                            {{$t('Email_label')}}
                          </th>
                          <td>
                            :
                          </td>
                          <td>
                            destek@arkman.com.tr
                          </td>
                        </tr>
                          <tr>
                          <th align="left">

                          </th>
                          <td>

                          </td>
                          <td>
&nbsp;
                          </td>
                        </tr>
                      </table>

                      <p>
                        <b>1.2 ALICI</b></p>
                      <table>
                        <tr>
                          <th align="left">
                            Firma Ünvanı
                          </th>
                          <td>
                            :
                          </td>
                          <td>
                            {{firmaUnvan}}
                          </td>
                        </tr>
                        <!-- <tr>
                          <th>
                            Adresi
                          </th>
                          <td>
                            :
                          </td>
                          <td>
                            {{Adres}}
                          </td>
                        </tr> -->
                        <tr>
                          <th align="left">
                              {{$t('Phonenumber_label')}}
                          </th>
                          <td>
                            :
                          </td>
                          <td>
                            {{Telefon}}
                          </td>
                        </tr>
                        <tr>
                          <th align="left">
                             {{$t('Email_label')}}
                          </th>
                          <td>
                            :
                          </td>
                          <td>
                            {{eposta}}
                          </td>
                        </tr>
                      </table>
                      <p>
                        <b>MADDE 2 - KONU</b></p>
                      <p>
                        İşbu sözleşmenin konusu, ALICI'nın SATICI'ya ait www.arkman.com.tr İnternet sitesinden
                        elektronik ortamda siparişini yaptığı aşağıda nitelikleri ve satış fiyatı belirtilen
                        ürünün satışı ve teslimi ile ilgili olarak 4077 sayılı Tüketicilerin Korunması Hakkındaki
                        Kanun ve Mesafeli Sözleşmeler Uygulama Esas ve Usulleri Hakkında Yönetmelik hükümleri
                        gereğince tarafların hak ve yükümlülüklerinin saptanmasıdır.</p>
                      <b>
                        <p>
                          MADDE 3 - SÖZLEŞME KONUSU ÜRÜN</p>
                      </b>
                      <p>
                        Ürünlerin Cinsi ve Türü, Miktarı, Marka/Modeli, Rengi ve Satış Bedeli ve Teslimat
                        Bilgileri aşağıda belirtildiği gibidir.<br />
                      </p>
                    - {{urunadet}} adet {{urunaciklama}}
                      <br />
                      <p>
                        <b>MADDE 4 - GENEL HÜKÜMLER</b></p>
                      <p>
                        4.1 ALICI, www.arkman.com.tr internet sitesinde sözleşme konusu ürünün temel nitelikleri,
                        tüm vergiler dahil satış fiyatı ve ödeme şekli ile teslimata ve bunun masraflarının
                        ALICI tarafından karşılanacağına ve SATICI’nın tam ticari unvanı, açık adresi ve
                        iletişim bilgilerine ilişkin ön bilgileri okuyup bilgi sahibi olduğunu ve elektronik
                        ortamda gerekli teyidi verdiğini beyan eder.</p>
                      <p>
                        ALICI; bu sözleşmeyi elektronik ortamda teyit etmekle, mesafeli sözleşmelerin akdinden
                        önce, Satıcı tarafından Tüketici'ye verilmesi gereken adres, siparişi verilen ürünlere
                        ait temel özellikler, ürünlerin vergiler dahil fiyatı, ödeme ve teslimat bilgilerini
                        de doğru ve eksiksiz olarak edindiğini teyid etmiş olur.</p>
                      <p>
                        4.2 Sözleşme konusu hizmet, sanal pos onayı alınıp para transferi yapıldığı anda,
                        ALICI veya gösterdiği adresteki kişi/kuruluşa, hizmetin alınan süresi kadar, kullanım
                        hakkı açılır.</p>
                      <p>
                        4.3 Sözleşme konusu hizmet, ALICI'dan başka bir kişi/kuruluşa teslim edilmeyecektir.Başka
                        bir kuruluşun bu hizmetten yararlanması için, tüzel kişilik olarak SATICI ile ayrı
                        bir hizmet anlaşması yapması gerekmektedir.</p>
                      <p>
                        4.6 SATICI, sipariş konusu ürün veya hizmetin yerine getirilmesinin imkansızlaşması
                        halinde sözleşme konusu yükümlülüklerini yerine getiremezse, bu durumu, sözleşmeden
                        doğan ifa yükümlülüğünün süresi dolmadan tüketiciye bildirir ve ALICI’ya eşit kalite
                        ve fiyatta aynı hizmeti tedarik edecektir.</p>
                      <p>
                        4.7 Sözleşme konusu hizmetin teslimatı için işbu sözleşmenin imzalı nüshasının SATICI'ya
                        ulaştırılmış olması ve bedelinin ALICI'nın tercih ettiği ödeme şekli ile ödenmiş
                        olması şarttır. Herhangi bir nedenle ürün bedeli ödenmez veya banka kayıtlarında
                        iptal edilir ise, SATICI hizmetin teslimi yükümlülüğünden kurtulmuş kabul edilir
                        ve ALICI ürün bedeli ödemez veya banka kayıtlarında iptal ederse, kullanılmış hizmetin
                        bedelinin SATICI tarafından tahsil edileceğini kabul etmiş sayılır.</p>
                      <p>
                        4.8 Ürünün tesliminden sonra ALICI'ya ait kredi kartının ALICI'nın kusurundan kaynaklanmayan
                        bir şekilde yetkisiz kişilerce haksız veya hukuka aykırı olarak kullanılması nedeni
                        ile ilgili banka veya finans kuruluşun ürün bedelini SATICI'ya ödememesi halinde,
                        ALICI'nın kullanmış olduğu hizmet bedelinin, 3 gün içinde SATICI'ya gönderilmesi
                        zorunludur.</p>
                      <p>
                        4.9 SATICI mücbir sebepler veya veri transferini engelleyen internet kopması, elektriklerin
                        kesilmesi gibi olağanüstü durumlar nedeni ile sözleşme konusu hizmetin süresi içinde
                        teslim edemez ise, durumu ALICI'ya bildirmekle yükümlüdür. Bu takdirde ALICI siparişin
                        iptal edilmesini hakkını kullanabilir. ALICI'nın siparişi iptal etmesi halinde ödediği
                        tutar 60 gün içinde kendisine nakden ve defaten ödenir.</p>
                      <p>
                        ALICI’nın kredi kartı ile yaptığı ödemelerde ise, hizmet tutarı, siparişin ALICI
                        tarafından iptal edilmesinden sonra 60 gün içerisinde ilgili bankaya iade edilir.
                        Bu tutarın bankaya iadesinden sonra ALICI hesaplarına yansıması tamamen banka işlem
                        süreci ile ilgili olup, SATICI’nın bu hususa ilişkin herhangi bir şekilde müdahalede
                        bulunması mümkün olamamaktadır.</p>
                      <b>MADDE 5 - CAYMA HAKKI</b> <b>
                        <p>
                          Tüketici; hizmet satışına ilişkin mesafeli sözleşmelerde, hizmetin satın alındığı
                          tarihten itibaren hizmeti kullanmaya başlamaktadır.Hizmet satın alındıktan sonra,
                          hizmeti (versiyon indirmek, telefon ve/veya internet üzerinden destek almak ) kullanmaya
                          başlamış olur ve cayma hakkı bulunmaz. Hizmet sunumuna ilişkin mesafeli sözleşmelerde
                          ise, bu süre sözleşmenin imzalandığı tarihte başlar.
                        </p>
                        <p>
                          Cayma hakkı kullanımında Alıcı hizmetin yararlandığı kadarını, Satıcıya ödemek ve
                          sonrasında hizmetten cayma hakkına sahiptir.</p>
                        <p>
                          Cayma hakkının kullanılması için 30 günlük süre içinde Satıcıya yukarıda bildirilen
                          faks, telefon veya eposta ile bildirimde bulunulması şarttır.</p>
                        a) 3. kişiye veya ALICI’ya teslim edilen ürünün faturası, (İade edilmek istenen
                        ürünün faturası kurumsal ise, iade ederken kurumun düzenlemiş olduğu iade faturası
                        ile birlikte gönderilmesi gerekmektedir. Faturası kurumlar adına düzenlenen sipariş
                        iadeleri İADE FATURASI kesilmediği takdirde tamamlanamayacaktır)<br />
                        b) İade formu,<br />
                        c) 30 günlük süre içerisinde iade edilecek hizmetin, kullanılmış kadarının SATICI’ya
                        ödenmesi gerekmektedir. Ödeme olmaması durumunda yapılmış hizmet satışı iptal ve
                        iade edilemez. Bu belgelerin SATICI’ya ulaşmasını takip eden 60 gün içinde ürün
                        bedeli ALICI'ya iade edilir.<br />
                        <p>
                          Hizmet SATICI’ya iade edilirken, hizmetin satın alımı sonrasında, ALICI adresine
                          gönderilmiş olan orijinal faturanın da (muhasebe kayıtlarımızda tutarlılığı sağlamak
                          amacıyla) iade edilmesi gerekmektedir.Faturanın 5 gün içerisinde SATICI’ya gönderilmemesi
                          durumunda iade işlemi gerçekleştirilmeyecek, satın alınmış hizmet ALICI tarafından
                          satın alınmış sayılacaktır. İade edilecek olan faturanın üzerine de "iade faturasıdır"
                          ibaresi yazılıp ALICI tarafından imzalanacaktır.</p>
                      </b><b>MADDE 6 - CAYMA HAKKI KULLANILAMAYACAK ÜRÜNLER</b>
                      <p>
                        Niteliği itibarıyla;kopyalanabilir yazılım ve programlar, ve yazılım destek hizmetlerinin
                        iadesi kabul edilmemektedir.</p>
                      <b>MADDE 7 - BORÇLUNUN TEMERRÜDÜ</b>
                      <p>
                        ALICI’nın temerrüde düşmesi halinde, ALICI, borcun gecikmeli ifasından dolayı SATICI’nın
                        oluşan zarar ve ziyanını ödemeyi kabul eder. ALICI’nın temerrüdünün SATICI’nın kusurundan
                        kaynaklandığı hallerde ALICI herhangi bir zarar ve ziyan talebini karşılamak mecburiyetinde
                        olmayacaktır.</p>
                      <b>MADDE 8 - YETKİLİ MAHKEME</b>
                      <p>
                        İşbu sözleşmenin uygulanmasında, Sanayi ve Ticaret Bakanlığınca ilan edilen değere
                        kadar Tüketici Hakem Heyetleri ile SATICI'nın yerleşim yerindeki Tüketici Mahkemeleri
                        yetkilidir. Siparişin onaylanması durumunda ALICI işbu sözleşmenin tüm koşullarını
                        kabul etmiş sayılır.</p>
                      <b>SATICI</b>
                      <p>
                        Arkman Bilgisayar Teknolojisi ve Yazılım Limited Şirketi</p>
                      <b>ALICI</b>
                      <p>
                        {{firmaUnvan}}</p>
                      <b>TARİH</b>
                      <p>
                        <span class="grey--text caption">
                                                                {{getDateNow() | dateformat}}
                                                                {{getdatetimenow()}}</span> </p>
                    </div>

                  </v-flex>
                </v-card>
              </div>
            </v-flex>

          </v-layout>

        </v-flex>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="info" flat @click="sozlesmeIptal()">{{ $t('OK') }}</v-btn>

          <v-progress-circular v-if="bekle" indeterminate color="info"></v-progress-circular>
        </v-card-actions>
      </v-card>
    </v-dialog>




    <v-card>
      <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
        :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
      </v-snackbar>
    </v-card>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import helpers from "@/components/app/customcomp/helpers.js"


  export default {
    props: ["value"],
    components: {

    },
    computed: {
      val: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue)
        },
      },
    },
    beforeMount: beforeMount,
    filters: {

      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },
      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },

    methods: {
        getDateNow() {
                return helpers.getDateNow();
            },

            getdatetimenow() {

                var timenow = helpers.getTimeNow();

                return String(timenow)
            },
      sozlesmeKabul() {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var paramssozlesme = {
          ID: null,
          SozlesmeID: this.mesaj.SozlesmeID,
          UserID: credentials.UserID,
          ConfirmDate: helpers.getDateTimeNow(),
        }

        this.$http.post(auth.API_URL + 'api/Awed/AwedWebContractConfirm', paramssozlesme, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader(),
            'CariSirketNo': credentials.SirketKodu.toString(),
            'CoperSirketNo': credentials.CoperSirketNo.toString(),
            'MusteriKodu': credentials.AnaSirketKodu.toString()
          }
        }).then((response) => {

          if (response.body.Status == true) {
            this.resolve(true);
            this.dialogyetki = false

          } else {

          }

          this.text1 = response.body.ResponseMessage;
          this.snackbar = true

        }, (response) => {
          this.text1 = 'Service Unavailable'
          this.snackbar = true


        })
      },
      sozlesmeIptal() {
        this.resolve(false);
        this.dialogyetki = false
      },


      open(mesaj, urunaciklama,urunadet) {
        var ml = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));
        var index = ml.AnaSirketInfo.map(function (e) {
          return e.MusteriKod;
        }).indexOf(mesaj);

this.urunaciklama=urunaciklama

if (urunadet==0 || urunadet==null){
  this.urunadet=1
}

this.urunadet=urunadet
        this.firmaUnvan = ml.AnaSirketInfo[index].MusteriUnvan
        this.Adres = null
        this.Telefon = ml.UserInfo.GSM
        this.eposta = ml.UserInfo.Email

        this.dialogyetki = true;

        return new Promise((resolve, reject) => {
          this.resolve = resolve;
          this.reject = reject;
        });

      },
    },
    data() {
      return {
     urunaciklama: null,
urunadet: null,
        firmaUnvan: null,
        Adres: null,
        Telefon: null,
        eposta: null,
        bekle: false,
        islem: 0,
        sozlesmeOnay: false,
        mesaj: null,
        alertshow: false,
        alertmodel: true,
        tahsilatbakiyem: 0,
        dialogbaslik: '',
        resolve: null,
        kaydetbuton: false,
        dialogyetki: false,
        k: null,
        doviztipi: [],
        reject: null,
        tahsilatdialog: false,
        text1: null,
        loading: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
      }
    },


    watch: {

    },
  }




  function beforeMount() {

  }
</script>
<style>
  header {
    font-family: 'Lobster', cursive;
    text-align: center;
    font-size: 25px;
  }

  #info {
    font-size: 18px;
    color: #555;
    text-align: center;
    margin-bottom: 25px;
  }

  a {
    color: #074E8C;
  }

  .scrollbar {
    margin-left: 10px;
    float: left;
    height: 300px;
    width: 100%px;
    background: rgb(255, 255, 255);
    overflow-y: scroll;
    margin-bottom: 25px;
  }

  .force-overflow {
    min-width: 800px;
  }

  #wrapper {
    text-align: center;
    width: 500px;
    margin: auto;
  }

  /*
 *  STYLE 1
 */

  #style-1::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #F5F5F5;
  }

  #style-1::-webkit-scrollbar {
    width: 12px;
    background-color: #F5F5F5;
  }

  #style-1::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
    background-color: royalblue;
  }
</style>